import React, {useEffect, useState} from "react";
import {getHostAddress, mainSet} from "../../Tool/UtileFun";
import {Button, Card, Input, message, Space, Table} from "antd";
import {TabButtons} from "../../Admin/ClassAndStudentParts/TabButtons";
import {ButtonAndModal} from "./ButtonAndModal";
import cookie from "react-cookies";


export function StudentTab(){
    useEffect(
        ()=>{
            findAll()
        },[]
    );


    const findAll=()=>{
        fetch(
            "http://"+getHostAddress()+"/user/findByClassId",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({classId:cookie.load("classID")}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                setUser(data)
                console.log(data)
            })
            .catch(error => message.error("error"+error));
    }

    const searchUser=(value)=>{
        fetch(
            "http://"+getHostAddress()+"/user/searchStudentName",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({name:value,classId:cookie.load("classID")}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                setUser(data)
                console.log("search-------")
                console.log(data)
            })
            .catch(error => message.error("error"+error));
    }

    const deleteClass=()=>{
        console.log(classId)
    }

    let classId = ""

    const buttons = () =>{
        return(
            <>
                <Button type="primary" >编辑</Button>
                <Button type="primary" danger onClick={deleteClass}>删除</Button>
            </>
        )
    }


    const [user,setUser]=useState([]);

    const { Search } = Input;

    const columns = [
        {
            title: '序号',
            width:80,
            render:(text,record,index)=>`${index+1}`

        },
        {
            title: '学号',
            dataIndex: 'studentNumber',
            key: 'studentNumber',
        },
        {
            title: '姓名',
            dataIndex: 'realName',
            key: 'realName',
        },
        // {
        //     title: '账户名',
        //     dataIndex: 'name',
        //     key: 'name',
        // },
        // {
        //     title: '角色',
        //     dataIndex: 'role',
        //     key: 'role',
        // },
        {
            title: '班级',
            dataIndex: 'className',
            key: 'ClassName',
        },
        {
            title: '操作',
            key: 'details',
            render: (userInfo) => (
                <>
                    <Space size="middle">
                        <ButtonAndModal props={userInfo}
                                        Event={()=>{
                                            findAll()
                                        }}
                        ></ButtonAndModal>
                    </Space>
                </>
            ),
        },

    ];

    let data = []

    return(
        <Card title={"学生管理"}>
            <Search placeholder="输入学生名称搜索"
                    onSearch={value => searchUser(value)}
                    enterButton
                    style={{width:500}}/>
            <Table
                columns={columns}
                dataSource={user}
                pagination={{
                    onChange: page => {
                        console.log(page);
                    },
                    pageSize: 5,
                }}
            ></Table>
        </Card>
    )
}
